export default "__VITE_ASSET__d06dd222__"